webpackJsonp([103869943198658],{

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _openSource = __webpack_require__(163);
	
	var _openSource2 = _interopRequireDefault(_openSource);
	
	var _openSourceCard = __webpack_require__(150);
	
	var _openSourceCard2 = _interopRequireDefault(_openSourceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenSourceprojects = function (_Component) {
	  _inherits(OpenSourceprojects, _Component);
	
	  function OpenSourceprojects() {
	    _classCallCheck(this, OpenSourceprojects);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OpenSourceprojects.prototype.render = function render() {
	    var projects = _openSource2.default.data.projects;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'mt-5 bg-green first-section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container pt-5' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'text-center text-white pl-0 maison-bold font-xl-x' },
	          'Open Source Projects'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'text-center  text-white roboto-regular font-xs-l p-4 px-5' },
	          _openSource2.default.data.content
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-md-center py-5' },
	          projects.map(function (project, key) {
	            return _react2.default.createElement(_openSourceCard2.default, { data: project, key: key });
	          })
	        )
	      )
	    );
	  };
	
	  return OpenSourceprojects;
	}(_react.Component);
	
	exports.default = OpenSourceprojects;
	module.exports = exports['default'];

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _index = __webpack_require__(65);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _seo = __webpack_require__(9);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenSource = function (_Component) {
	  _inherits(OpenSource, _Component);
	
	  function OpenSource() {
	    _classCallCheck(this, OpenSource);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OpenSource.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'first-section' },
	      _react2.default.createElement(_seo2.default, { isDynamic: false,
	        title: 'Contributions by Gojek towards free and open source software',
	        description: 'Gojek understands and appreciates the value of free and open source software. Check out some of our contributions towards the community on our GitHub page.',
	        url: 'https://gojek.io'
	      }),
	      _react2.default.createElement(_index2.default, null)
	    );
	  };
	
	  return OpenSource;
	}(_react.Component);
	
	exports.default = OpenSource;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-open-source-js-9352bc80ea07bbedf484.js